module.exports = __webpack_public_path__ + "img/pizzeria.889f0def.png";